import { render, staticRenderFns } from "./wxck.vue?vue&type=template&id=2c3c823f&scoped=true&"
import script from "./wxck.vue?vue&type=script&lang=js&"
export * from "./wxck.vue?vue&type=script&lang=js&"
import style0 from "./wxck.vue?vue&type=style&index=0&id=2c3c823f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c823f",
  null
  
)

export default component.exports